(function () {
    var orderPaymentMethods = [
        "Unknown",
        "In Store",
        "PayOnline",
        "COD",
        "COD",
    ];

    function orderPaymentMethodFilter () {
        return function (input) {

            // If the input is undefined or null, we return undefined|null so that bind once continues to bind until the value is not null.
            if (!input) {
                return input;
            }

            return orderPaymentMethods[input];
        };
    }

    angular
        .module('dashboard')
        .filter('orderPaymentMethod', [ orderPaymentMethodFilter ]);
})();
